export const arrayFromEnum = <T>(
  value: Record<string | number | symbol, T>,
): T[] => {
  return value ? Array.from(Object.values(value)) : [];
};
